import { render, staticRenderFns } from "./RocketMQPdRes.vue?vue&type=template&id=6cdc1040&scoped=true&"
import script from "./RocketMQPdRes.vue?vue&type=script&lang=js&"
export * from "./RocketMQPdRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc1040",
  null
  
)

export default component.exports